/**
 * Окно «Выберите, что оставить» для слишком вытянутого фото (правило 5 подгонки фото, владелец 29.09):
 * вызов из любого места загрузки — промис с рамкой, которую выбрал клиент, или null (закрыл окно).
 *
 * Отдельный модуль, а не экспорт из ImageCropHost.tsx: файл с компонентом должен экспортировать только
 * компоненты (react-refresh), а CI проверяет изменённые файлы без единого предупреждения.
 */
import type { CropRect } from '../pages/generate/utils/imageInput'

export interface ImageCropRequest {
	/** Адрес картинки для показа (object URL исходника). */
	url: string
	/** Размер исходника в пикселях (с учётом поворота из EXIF). */
	width: number
	height: number
	/** Предельная пропорция модели: длинная сторона к короткой (2,5 у Seedance). */
	ratio: number
}

type Opener = (req: ImageCropRequest, resolve: (rect: CropRect | null) => void) => void

let opener: Opener | null = null

/** Хост окна (ImageCropHost в App) регистрирует себя при монтировании и снимает при размонтировании. */
export function registerImageCropOpener(fn: Opener | null): void {
	opener = fn
}

// Окна — по очереди: два фото, дошедшие до окна почти разом (два слота подряд), не отменяют друг друга —
// второе ждёт, пока клиент закроет первое.
let queue: Promise<unknown> = Promise.resolve()

/** Спросить у клиента рамку. Хоста нет (редкий случай — страница без App) — null, как отмена. */
export function requestImageCrop(req: ImageCropRequest): Promise<CropRect | null> {
	if (!opener) return Promise.resolve(null)
	const run = queue.then(
		() =>
			new Promise<CropRect | null>((resolve) => {
				const open = opener
				if (open) open(req, resolve)
				else resolve(null)
			}),
	)
	queue = run.catch(() => null)
	return run
}
